import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastsManager } from 'ng2-toastr';
import { AuthService } from '../service/auth.service';
import { EcomicService } from '../service/comics/ecomic.service';
declare const swal: any;
declare var $: any;
@Component({
  selector: 'app-upcoming-releases',
  templateUrl: './upcoming-releases.component.html',
  styleUrls: ['./upcoming-releases.component.css']
})
export class UpcomingReleasesComponent implements OnInit {
  UpcommingReleases = [];
  id: any;


  constructor(private form: FormBuilder, private router: Router, private afs: AngularFirestore, private comicService: EcomicService,
    private route: ActivatedRoute, private auth: AuthService, public toastr: ToastsManager, vcr: ViewContainerRef,private http:HttpClient) {
    this.toastr.setRootViewContainerRef(vcr);
  }


  ngOnInit() {
    this.GetAllOffers();
  }
 async GetAllOffers(){
  try {

    const offers = await this.afs.collection(`UpcomigReleases`, res => {
      return res.orderBy('createdAt',"desc");
    });
    const data = await offers.valueChanges();
    data.subscribe(async (response)=>{
      this.UpcommingReleases = response;
      console.log(this.UpcommingReleases)
    })
    
  } catch (error) {
    throw error;
  }
 }
 delete(id) {
  console.log(id);
  this.id = id;
  $("#DeleteModal").modal();
}
deletedata() {
  $('#DeleteModal').modal('hide');
      this.afs.doc('/UpcomigReleases/'+this.id).delete().then(function () {  
        swal('Deleted!', 'Your List has been deleted.', 'success');
      }).catch(function(error){
        swal('Error!', error, 'error');
        console.error("error in removing document:",error);
      });
   
}
}



// WEBPACK FOOTER //
// ./src/app/upcoming-releases/upcoming-releases.component.ts